import { EventsPerTournamentEntry } from "@api-types/events-with-results-per-tournaments";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getTimeSpan } from "@utils/datetime/datetimeCalculators";

export default class EventsPerTournamentApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/events-with-results-per-tournaments`;

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static getEvents(filter: {
		startDayFromToday: number;
		endDayFromToday: number | null;
	}): Promise<EventsPerTournamentEntry[]> {
		const context = getApiRequestContext();
		const timeFilter = getTimeSpan(
			filter.startDayFromToday,
			filter.endDayFromToday
		);

		return httpClient.get(
			`${this.baseUrl}?from=${timeFilter.from}&to=${timeFilter.to}&translate=True&rpp=7000`,
			this.getRequestHeaders(context)
		);
	}
}
